<template lang="pug">
v-container(fluid fill-height class=" tw-w-full tw-h-full tw-max-h-full tw-m-0 tw-p-0")
  v-row(no-gutters justify="space-around" class="tw-h-full")
    v-col(cols="5")
      v-row
        v-col(cols="12")
          v-carousel(height="307px" hide-delimiters :key="index") 
            |
            |
            |
            v-carousel-item(
              v-if="images.length != 0"
              v-for="image in images"
              :key="image.id"
              :src="path(image.path)"
              height="307"
              :width="imageWidth()"
            )

            v-carousel-item(v-if="images.length == 0" :src="require('@/assets/images/placeholder-image.jpg')")

      v-row
        v-col(cols="stretch")
          dropzone(
            id="customdropzone"
            ref="dropzone"
            v-on:vdropzone-sending="vsending"
            v-on:vdropzone-file-added="fileAdded"
            v-on:vdropzone-thumbnail="thumbnail"
            v-on:vdropzone-total-upload-progress="vprogress"
            v-on:vdropzone-queue-complete="uploadComplete"
            :options="options"
            :include-styling="false"
            :useCustomSlot="true"
          )
            div(
              v-show="uploading != true"
              :key="index"
              class="dropzone-custom-content tw-self-stretch  tw-pt-8 tw-z-0 tw-relative "
            )
              div(class="tw-pb-2")
                v-icon(x-large) mdi-tray-arrow-up
              div
                span(class="tw-capitalize") {{ $t('Listings.Common.uploadPhotos') }}
    v-col(cols="6" class="tw-max-h-full tw-h-full tw-ml-4")
      div(class=" tw-overflow-y-auto tw-max-h-full tw-border-gray-lighten-3 tw-border tw-h-full")
        div(class="tw-flex-wrap tw-relative tw-overflow-y-auto tw-h-full tw-max-h-full tw-flex")
          div(class="tw-absolute tw-z-0")
            draggable(
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
              :move="checkMove"
              v-model="images"
              class="list-group tw-h-full tw-flex-wrap tw-flex tw-justify-between tw-px-5"
            )
              transition-group(
                type="transition"
                :name="!drag ? 'flip-list' : null"
                v-for="image in images"
                :key="image.id"
              )
                div(class="tw-flex tw-p-1 tw-py-2 " @click="image.fixed = !image.fixed" :key="image.id")
                  kubiqa-gallery-image(:item="image")
          div(
            v-if="images.length == 0"
            class=" fill-height tw-w-full tw-items-center tw-absolute tw-z-10 tw-justify-items-center  tw-content-center"
            :key="index"
          )
            v-row(justify="center" align="center" class="fill-height")
              v-cols(cols="auto")
                v-row(justify="center")
                  v-col(cols="auto")
                    v-lottie-player(
                      :loop="true"
                      width="200px"
                      height="200px"
                      :animation-data="require('@/assets/animations/photos-add.json')"
                    )
</template>
<script>
export default {
  data() {
    return {
      drag: false,
      index: 1,
      gallery_id: '',
      uploading: false,
      options: {
        url: process.env.VUE_APP_APIURL + '/api/bin',
        autoProcessQueue: false,
        withCredentials: true,
        thumbnailWidth: 80,
        thumbnailHeight: 80,
        acceptedFiles: 'image/*',
        thumbnailMethod: 'crop',
        //addRemoveLinks: 'true',
        maxFilesize: 4,
        //previewTemplate: $('#tpl').html(),
        //previewTemplate: document.querySelector('#template').innerHTML,
        previewTemplate: this.template(),
        //previewsContainer: '.previews',

        //headers: { "X-CSRF-TOKEN": document.cookie.match('XSRF-TOKEN')[0] },
        init: function () {
          this.on('success', function (file, json) {
            this.removeFile(file);
          });
        },
      },
    };
  },
  computed: {
    images: {
      get() {
        return this.$store.getters['galleries/images'];
      },
      set(images) {
        this.index++;
        this.$store.dispatch('galleries/updateImageList', images);
      },
    },
    dragOptions() {
      return {
        animation: 400,
        group: 'images',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  mounted() {
    let property = this.$store.getters['properties/property'];
    if (!property.gallery.length) {
      let data = {};
      data.type = 'photos';
      data.parent_id = property.id;
      data.parent_type = 'App\\Models\\Property';
      this.$store.dispatch('galleries/addGallery', data);
    } else {
      this.gallery_id = this.$store.getters['properties/property'].gallery.find(({ type }) => type === 'photos').id;
    }
    //this.gallery_id = (this.$store.getters['properties/property'].gallery).find(({type}) => type === 'photos').id
  },
  methods: {
    fileAdded(file) {
      this.uploading = true;
      this.index++;
      const data = new FormData();
      data.append('gallery_id', this.gallery_id);
      data.append('file', file);
      this.$store
        .dispatch('galleries/addImage', data)
        .then((response) => {
          this.$refs.dropzone.processQueue();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    uploadComplete() {
      this.uploading = false;
    },
    vprogress(totalProgress, totalBytes, totalBytesSent) {
      this.progress = true;
      this.myProgress = Math.floor(totalProgress);
    },
    vsending(file, xhr, formData) {
      this.sending = true;
      // window.toastr.warning('', 'Event : vdropzone-sending')
    },
    getToken() {
      this.$http.get(process.env.VUE_APP_APIURL + '/sanctum/csrf-cookie').then((response) => {
        return 'response.data';
      });
    },
    template() {
      return `
                    <div class="dz-preview dz-file-preview tw-inline-block">
                        <div class="dz-image">
                            <div data-dz-thumbnail-bg></div>
                        </div>
                        <div class="dz-progress"><div class="dz-upload" data-dz-uploadprogress></div></div>
                        <div class="dz-error-message"><span data-dz-errormessage></span></div>
                        <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                        <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                    </div>
                `;
    },
    checkMove(evt) {
      var image = evt.draggedContext.element;
      delete image.updated_at;
      delete image.created_at;
      image.order = evt.draggedContext.futureIndex;
      this.$store
        .dispatch('galleries/updateImage', image)
        .then((response) => {})
        .catch((error) => console.log(error));

      // this.$store.dispatch('galleries/getImages', this.$store.getters['galleries/gallery'])
    },
    imageWidth() {
      if (screen.width > 1900) {
        return '100%';
      } else if (screen.width < 1440) {
        return 380;
      } else {
        return 420;
      }
    },
    thumbnail: function (file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove('dz-file-preview');
        ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function (_this) {
            return function () {
              return file.previewElement.classList.add('dz-image-preview');
            };
          })(this),
          1
        );
      }
    },
  },
};
</script>

<style lang="css">
.k-gallery-item-container {
  width: 120px;
  max-width: 120px;
}
.v-carousel .v-btn {
  margin: 0px !important;
}
.ghost {
  opacity: 0.5;
  background: #fff;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

#customdropzone {
  background-color: #f3f3f3;
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color 0.2s linear;
  height: 200px;
  padding: 10px;
  padding-bottom: 50px;
  overflow-y: scroll;
  text-align: center;
  justify-items: space-between;
}

#customdropzone .dz-preview {
  width: 100px;
  height: 100px;
  display: inline-block;
}
#customdropzone .dz-preview .dz-image {
  width: 80px;
  height: 80px;
  margin-left: 10px;
  margin-bottom: 10px;
  position: absolute;
  z-index: 10;
}
#customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 10%;
  background-size: contain;
}
#customdropzone .dz-preview .dz-image > img {
  width: 100%;
  height: 80px;
}

#customdropzone .dz-preview .dz-details {
  color: white;
  transition: opacity 0.2s linear;
  text-align: center;
}

#customdropzone .dz-progress {
  height: 30px;
  width: 100%;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 25px;
  overflow: hidden;
  position: relative;
  z-index: 20;
  top: 40px;
}

#customdropzone .dz-progress .dz-upload {
  background-color: white;
  opacity: 70%;
  height: 10px;
  border-radius: 20px;
  width: 0px;
}

#customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}
.k-carousel-container {
  width: 380px;
  max-width: 380px;
}
</style>
